//identify.js
import request from '@/utils/request';

export function postSetNewPassword(data) {
  return request({
    url: '/v1/user_info/password/modify_by_email',
    method: 'post',
    data: data,
  });
}

export function postSetNewPasswordPhone(data) {
  return request({
    url: '/v1/user_info/password/modify_by_phone',
    method: 'post',
    data: data,
  });
}
